import request from 'checkout/utils/axios'

export const getOrders = async hash =>
  await request
    .get('/user-sale-orders', { params: { hash: hash || null } })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

export const getOrdersToPay = async hash =>
  await request
    .get('/user-pending-payment-sale-orders', {
      params: { hash: hash || null }
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })
